import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {Observable, of} from 'rxjs';
import {catchError, debounceTime, distinctUntilChanged, map, tap, switchMap} from 'rxjs/operators';
import { ShippingGlossaryService} from '../../../../shared/services/shipping-glossary.service';

type SearchshippingGlossary = {value: string, name: string};

@Component({
    selector: 'app-shipping-glossary',
    templateUrl: './shipping-glossary.component.html',
    styleUrls: ['./shipping-glossary.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShippingGlossaryComponent implements OnInit {

  constructor(private shippingGlossaryService:ShippingGlossaryService) { }

  searching:boolean = false;
  searchFailed:boolean = false;
  searchShoppingGlossaryKey:any;

  isLoader:boolean = false;
  searchDetailsList:any = [];
  ngOnInit(): void {
  }


  // ORIGIN ADDRESS 
  formatteShippingGlossary = (searchshippingGlossary: SearchshippingGlossary) => searchshippingGlossary.value.trim();
  searchShippingGlossary = (text$: Observable<string>) => text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    tap(() => this.searching = true),
    switchMap(term =>  
      this.shippingGlossaryService.searchShippingGlossary(term).pipe(
        tap(() => this.searchFailed = false),
        catchError(() => {
          this.searchFailed = true;
          return of([]);
        }))
    ),
    tap(() => this.searching = false)
  )

  SearchByName(){
    if(this.searchShoppingGlossaryKey && this.searchShoppingGlossaryKey.value.trim() && this.searchShoppingGlossaryKey.value != 'No Results Found'){
      this.isLoader = true;
      this.shippingGlossaryService.getShoppingDetailsByName(this.searchShoppingGlossaryKey.value).subscribe((res)=>{
        this.searchDetailsList = [];
        this.searchDetailsList = res;
        this.isLoader = false;
      },(error)=>{
        this.isLoader = false;
      })
    }
  }

  shwoAllShippingGlossaryByName(){
    this.isLoader = true;
    this.shippingGlossaryService.getShoppingDetailsByNameAll().subscribe((res)=>{
      this.searchDetailsList = [];
      this.searchDetailsList = res;
      this.isLoader = false;
     },(error)=>{
      this.isLoader = false;
    })
  }


  
}
